import React, { useRef } from 'react'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearAllFilters } from 'Pods/SearchPage/Store/actions'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import { getFiltersCount } from 'Pods/SearchPage/Store/selectors'

function ClearFiltersButton() {
  const translate = useTranslate()
  const hasActiveFilters = useSearchPageStore(state => getFiltersCount(state) > 0)
  const wrapperRef = useRef(null)

  const handleClear = (event) => {
    // Clearing unmounts this button, which would drop keyboard focus to <body>; hand it to the
    // More Filters trigger right before it instead.
    if (document.activeElement === event.currentTarget) {
      wrapperRef.current?.previousElementSibling?.querySelector('[role="button"]')?.focus()
    }
    clearAllFilters()
  }

  if (!hasActiveFilters) return null

  return (
    <div ref={wrapperRef} className="main-filters__clear">
      <div className="main-filters__clear-divider" aria-hidden="true" />
      <button
        type="button"
        className="main-filters__clear-button cgt-link-secondary"
        onClick={handleClear}
      >
        {translate('search_page.filters.clear_all')}
      </button>
    </div>
  )
}

export default ClearFiltersButton
